export enum UserDefinedWidgetType {
  LINE_WITH_SIGNALS_PER_AXIS = 'LINE_WITH_SIGNALS_PER_AXIS',
  BAR = 'BAR',
  GAUGE = 'GAUGE',
  TEXT = 'TEXT',
  ADMIN_CHARTS = 'ADMIN_CHARTS',
  FLATNESS = 'FLATNESS',
  ANALYSIS_LINE = 'ANALYSIS_LINE',
  IMAGE = 'IMAGE',
  MAP = 'MAP',
  STATUS = 'STATUS',
  PIE = 'PIE',
  COMMAND = 'COMMAND'
}
